import {
  ADD_DRAFT_ORDER,
  DELETE_DRAFT_ORDER,
  GET_DRAFT_ORDER_BY_ID,
  GET_DRAFT_ORDER_LIST
} from './ApiConstants';
import api from './ApiHandler';

export interface DraftOrdersPayloads {
  orderBy: string;
  totalAmount: number;
  note: string;
  requestedDeliveryDate: string;
  poNumber: string;
  status: string;
  categoryId: number;
  subCategoryId: number;
  quantity: number;
  productId: number;
  price: number;
  productName: string;
}

export const draftOrder = async (payload: any) => {
  return await api.post(ADD_DRAFT_ORDER, { ...payload });
};

export const getDraftOrdersByPage = async (payload: any) => {
  return await api.get(GET_DRAFT_ORDER_LIST, { params: payload });
};

export const getDraft = async (payload: any) => {
  return await api.get(GET_DRAFT_ORDER_BY_ID, { params: { ...payload } });
};

export const deleteOrder = async (payload: any) => {
  return await api.post(DELETE_DRAFT_ORDER, { ...payload });
};
